import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=12917184&"
import script from "./Overlay.vue?vue&type=script&lang=ts&"
export * from "./Overlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports